var React = require('react');

function InvoiceFinancing (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.6847 10.6245V0.290649H0.125732V39.8655H27.9636V10.6245H17.6847ZM19.9538 22.0284H17.7531V19.982C17.4068 19.5163 16.4583 18.6936 14.8092 18.6936C13.0742 18.6936 12.0917 19.5771 11.7253 20.1741V23.5672H17.3778V25.7815H11.7253V29.4373C11.7253 29.8106 11.6216 30.2348 11.4291 30.6556H17.7531V28.3074H19.9538V32.8704H8.25918V30.6556C9.02648 30.6556 9.51083 29.6971 9.52213 29.4344V25.7815H8.25918V23.5672H9.52213V19.661L9.62086 19.4432C10.2865 17.9692 12.1487 16.4798 14.8092 16.4798C17.7256 16.4798 19.3742 18.2423 19.8389 19.1776L19.9538 19.4102V22.0284Z","fill":"currentColor"}));
}

InvoiceFinancing.defaultProps = {"width":"28","height":"40","viewBox":"0 0 28 40","fill":"none"};

module.exports = InvoiceFinancing;

InvoiceFinancing.default = InvoiceFinancing;
